import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import searchKeysSlice from "./slices/searchKeysSlice";
import contractPaginateSlice from "./slices/contractPaginateSlice";
import phoneValidationSlice from "./slices/phoneValidationSlice";
import signedDateSlice from "./slices/signedDateSlice";
import discountSlice from "./slices/discountSlice";
import leadProposalPaginateReducer from "./slices/leadPaginationSlice";
import agreementPaginateReducer from "./slices/agreementPaginationSlice";

const rootReducer = combineReducers({
  searchKeysReducer: searchKeysSlice,
  contractPaginatedReducer: contractPaginateSlice,
  phoneValidationReducer: phoneValidationSlice,
  signedDateReducer: signedDateSlice,
  discountReducer: discountSlice,
   leadProposalPaginatedReducer: leadProposalPaginateReducer,
   agreementPaginatedReducer: agreementPaginateReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
